import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M21 8q.8 0 1.4.6T23 10v2q0 .176-.05.375-.05.2-.1.375l-3 7.05q-.225.5-.75.85T18 21H7V8l6-5.95q.375-.375.888-.437t.987.187q.475.25.7.7.226.45.1.925L14.55 8zM9 8.85V19h9l3-7v-2h-9l1.35-5.5zM4 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19v-9q0-.825.588-1.412A1.93 1.93 0 0 1 4 8h3v2H4v9h3v2z"
    }, null, -1)
  ]))]))
}
export default { render: render }